import { SvgIcon } from '@material-ui/core';
import React from 'react';

export default function FormHeader ( props ) {
    const { title, Icon } = props;
    return (
        <div>
            {Icon ? <div className="text-center mt-3">
                <SvgIcon color="primary" className="iconsSvg" component={Icon} />
            </div> : ""}
            <h4 className="text-center mt-3 mb-4">
                <b>{title}</b>
            </h4>
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/FormHeader.js